var DeliveryModeSwitcherView = (function (_checkoutSettings) {
    var generalAddressSelector = '@generalDelivery';
    var addGiftAddressSelector = '@addGiftAddress';
    var addBillingAddressSelector = '@addBillingAddress';
    var hiddenBlockClass = 'hidden-block';

    var _switch = function (mode) {

        var _settings = _checkoutSettings.getBasketSettings();
        if (_settings && _settings.GiftEnabled) {

            $(generalAddressSelector).toggleClass(hiddenBlockClass, mode !== 0);
            //$(addGiftAddressSelector).toggleClass(hiddenBlockClass, mode !== 1);
            //$(addBillingAddressSelector).toggleClass(hiddenBlockClass, mode !== 1);

        } else {
            $(addGiftAddressSelector).remove();
            $(addBillingAddressSelector).remove();
            $(generalAddressSelector).toggleClass(hiddenBlockClass, false);
        }
    };

    return function (checkoutModel) {

        var deliveryModel = checkoutModel.get('Delivery');
        var deliveryModeSwitcherModel = deliveryModel.get('DeliveryModeSwitcher');

        _switch(deliveryModeSwitcherModel.get('BasketMode'));
        deliveryModeSwitcherModel.on('change:BasketMode', function (m) {
            _switch(m.get('BasketMode'));
        });
        window.deliveryModeSwitcherModel = deliveryModeSwitcherModel;
    };

})(CheckoutSettings);